export default "__VITE_ASSET__CnOALk40__"